<script setup lang="ts">
interface Props {
  heading: string
  text?: string
}

defineProps<Props>()

const { LocalConfigurationStore } = stores()
</script>
<template>
  <div class="flex flex-col gap-2 p-8 text-center justify-center items-center">
    <div>
      <div class="flex flex-col items-center text-xl font-bold">
        <span class="icon-[ph--info-bold] text-4xl" />
        {{ heading }}
      </div>
      <div class="leading-tight">
        {{ text }}
      </div>
    </div>
    <GridComponent
      v-if="LocalConfigurationStore?.brokerContext?.contact?.length"
      :cols="3"
      :min-cols="1"
      gap="xs"
    >
      <PvButton
        v-for="contact in LocalConfigurationStore?.brokerContext?.contact?.filter(
          (c) => c.type === 'c-to-b'
        )"
        :key="contact.name"
        outlined
        :size="$viewport.isLessThan('md') ? 'small' : 'large'"
        class="text-surface-0"
        @click="navigateTo(contact.href, { open: { target: '_blank' } })"
      >
        <div class="flex gap-1 items-center">
          <span
            v-if="contact.iconClass"
            class="text-2xl"
            :class="getIconClass(contact.iconClass)"
          />
          <div class="text-sm text-center md:text-left w-full">
            {{ contact.contact }}
          </div>
        </div>
      </PvButton>
    </GridComponent>
  </div>
</template>
